
export default {
  productData: {
    serialNumber: 'DA-HMUF-005',
    name: 'Holzbalkendecken mit Unterdecken an Federschienen | Aufbau 5',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Zementgebundene Spanplatte ZSP oder Gipsfaserplatte GF' },
          output: '≥ 22',
          value: 'd-22'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 30 MN/m<sup>3</sup>; Anwendungsgebiet DES-sm)' },
          output: '≥ 20',
          value: 'm-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 45 kg/m<sup>2</sup>), ggf. Rieselschutz' },
          output: '≥ 30',
          value: 'scsb-30'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken oder Stegträger' },
          output: '220',
          value: 'bs-220'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '100',
          value: 'h-100'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Federschiene' },
          output: '27',
          value: 'f-27'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '353,5', value: 353.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '41 (2)',
        value: 41
      },
      soundReductionIndex: { // Rw
        output: '69 (-4; -11)',
        value: 69
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,29',
        value: 0.29
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '122,4 [kg/m²]'
      }
    }
  },
  image: 'da-hmuf-005.png',
  pdf: 'Holzbalkendecken-mit-Unterdecken-an-Federschiene-Aufbau-5-DA-HMUF-005-Rev03.pdf'
}
